import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Dropdown/Dropdown.tsx
import React, { forwardRef } from "react";
import clsx from "clsx";
import { Popover } from "@headlessui/react";
var DEFAULT_COMPONENT = "div";
var Dropdown = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      className
    } = _b,
    rest = __objRest(_b, ["as", "children", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  return /* @__PURE__ */React.createElement(Popover, __spreadProps(__spreadValues({
    ref,
    as: Component
  }, rest), {
    className: clsx("pd-dropdown", className)
  }), _ref => {
    let {
      open
    } = _ref;
    return (
      // 'useless' Fragment is by design. ESLint is dumb.
      // eslint-disable-next-line react/jsx-no-useless-fragment
      /* @__PURE__ */
      React.createElement(React.Fragment, null, typeof children === "function" ? children({
        open
      }) : children)
    );
  });
});
var StoryDropdown = args => /* @__PURE__ */React.createElement(Dropdown, __spreadValues({}, args));
var Dropdown_default = Dropdown;
export { StoryDropdown, Dropdown_default };